module.exports = __webpack_public_path__ + "img/alert-red.39c52eb9.svg";